<template style="height: 100%;">
  <div class="ExmCon">
    <el-dialog :title="$t('original.languages179')" :visible.sync="dialogTableVisible" width="38%">
      <table
        style="background: rgb(245, 247, 250); border-radius: 18px; width: 100%"
      >

        <tr>
          <td class="td_left"> {{ $t('original.languages185') }} ：</td>
          <td class="td_right">{{ Information.CounselorID }}</td>
        </tr>
        <tr>
          <td class="td_left">{{ $t('original.languages218') }}：</td>
          <td class="td_right">{{ Information.VisitorID }}</td>
        </tr>
        <tr>
          <td class="td_left">{{ $t('original.languages219') }}：</td>
          <td class="td_right">{{ Information.RelieveRecordNum }}</td>
        </tr>
        <tr>
          <td class="td_left">{{ $t('original.languages239') }}：</td>
          <td class="td_right">{{ Information.Assessment }}</td>
        </tr>

        <tr>
          <td class="td_left">{{ $t('original.languages220') }}：</td>
          <td class="td_right">
            {{
              Information.RelieveRecordCause == ''
              ? $t('original.languages220')
                : Information.RelieveRecordCause
            }}
          </td>
        </tr>
      </table>

      <table style="margin-top:20px; width:100%">
        <tr>
          <td class="td_left">{{ $t('original.languages190') }}</td>
          <td
            class="td_right"
            :style="
              Information.RelieveRecordState == 0
                ? 'color: rgba(0, 136, 255, 1);'
                : Information.RelieveRecordState == -1
                ? 'color: rgba(242, 75, 78, 1);'
                : Information.RelieveRecordState == 1
                ? 'color: rgba(21, 191, 109, 1); '
                : 'color: rgba(141, 141, 141, 1);'
            "
          >
            {{
              Information.RelieveRecordState == 1
              ? $t('original.languages227')
                : Information.RelieveRecordState == 3
              ? $t('original.languages204')
                : Information.RelieveRecordState == 2
              ? $t('original.languages203')
              : $t('original.languages205')
            }}
          </td>
        </tr>
        <tr v-if="Information.RelieveRecordState == 3 && Information.Isshow">
          <td class="td_left">{{ $t('original.languages215') }}</td>
          <td class="td_right">{{ Information.RelieveRecordNotes }}</td>
        </tr>
        <tr
          v-if="
            (Information.RelieveRecordState == 2 ||
              Information.RelieveRecordState == 3) &&
              Information.Isshow
          "
        >
          <td class="td_left">{{ $t('original.languages192') }}</td>
          <td class="td_right">{{ Information.ApproverID }}</td>
        </tr>

        <tr
          v-if="
            (Information.RelieveRecordState == 2 ||
              Information.RelieveRecordState == 3) &&
              Information.Isshow
          "
        >
          <td class="td_left"> {{ $t('original.languages193') }}</td>
          <td class="td_right">{{ Information.ApproverTime }}</td>
        </tr>

        <tr v-if="Information.RelieveRecordState == 1">
          <td class="td_left">{{ $t('original.languages215') }}</td>
          <td class="td_right">
            <el-input
              :placeholder="$t('original.languages215')"
              type="textarea"
              v-model="Information.RelieveRecordNotes"
            ></el-input>
          </td>
        </tr>
      </table>

      <div
        class="buttons"
        style="width: 100%"
        v-if="Information.RelieveRecordState == 1"
      >
        <el-button
          type="primary"
          @click="
            UpdateRelieveRecordState(
              (Information.RelieveRecordState = 3),
              Information.RelieveRecordID
            )
          "
        >
           {{ $t('original.languages195') }}
        </el-button>
        <el-button
          type="primary"
          @click="
            UpdateRelieveRecordState(
              (Information.RelieveRecordState = 2),
              Information.RelieveRecordID
            )
          "
        >
           {{ $t('original.languages196') }}
        </el-button>
      </div>
    </el-dialog>

    <el-tabs type="border-card" class="list-cnt">
      <el-tab-pane :label="$t('original.languages197')">
        <span slot="label">{{ $t('original.languages197') }}</span>
        <el-table
          :data="UndoTableData"
          v-loading="IsDataLoad"
          :element-loading-text="$t('original.languages197')"
        >
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="UserID" :label="$t('original.account')"></el-table-column>

          <el-table-column prop="RealName" :label="$t('original.name')"></el-table-column>

          <el-table-column prop="Sex" :label="$t('original.gender')"></el-table-column>

          <el-table-column prop="ConsultantCertificate"
            :label="$t('original.languages240')"></el-table-column>

          <el-table-column
            prop="CreatedDate"
            :label="$t('original.languages223')"
          ></el-table-column>
          <!-- <el-table-column label="审批状态" width="100">
            <template>
              <span class="state-blue"> 待审核 </span>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('original.languages49')" width="100" align="center">
            <template slot-scope="scope">
              <span
                class="option-blue"
                @click="
                  handleCheck(scope.row);
                  Information.Isshow = false;
                "
              >
                 {{ $t('original.languages201') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="UndoCount" v-if="UndoCount > 0"></el-pagination>
      </el-tab-pane>
      <el-tab-pane :label="$t('original.languages202')">
        <el-table  :data="DoTableData"  v-loading="IsDataLoad"  :element-loading-text="$t('original.languages22')" >
          <el-table-column :label="$t('original.The_serial_number')" width="100px">
            <template slot-scope="scope">
              {{ (pageIndex - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="VisitorID" :label="$t('original.languages218')"></el-table-column>

          <el-table-column prop="RelieveRecordNum" :label="$t('original.languages219')"></el-table-column>
          <el-table-column prop="Used" :label="$t('original.languages222')"></el-table-column>
          <el-table-column prop="RelieveRecordCause" :label="$t('original.languages220')"></el-table-column>
          <el-table-column prop="CounselorID" :label="$t('original.languages185')"></el-table-column>
          <el-table-column prop="CreatorTime" :label="$t('original.languages217')"></el-table-column>

          <el-table-column :label="$t('original.languages190')" width="100">
            <template slot-scope="scope">
              <span class="state-green" v-if="scope.row.RelieveRecordState == 2">
                {{ $t('original.languages203') }}
              </span>
              <span class="state-red" v-else-if="scope.row.RelieveRecordState == 3">
                 {{ $t('original.languages204') }}
              </span>
              <span class="state-gray" v-else>  {{ $t('original.languages205') }} </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('original.languages49')" width="100">
            <template slot-scope="scope">
              <span class="option-blue" @click="handleCheck(scope.row);
                  Information.Isshow = true;">
                 {{ $t('original.languages174') }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndex" :page-size="pageSize" layout="total, prev, pager, next" :total="DoCount" v-if="DoCount > 0"></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  data() {
    return {
      IsDataLoad: true,
      dialogTableVisible: false, //打开详情框
      pageSize: 10,
      pageIndex: 1,
      UndoTableData: [],
      DoTableData: [],
      UndoCount: -1,
      DoCount: -1,
      appointmentList: [],
      Information: {
        RelieveRecordID: '',
        VisitorID: '',
        RelieveRecordNum: '',
        Used: '',
        RelieveRecordCause: '',
        CreatorTime: '',
        RelieveRecordState: '',
        Assessment: '',
        CounselorID: '',
        RelieveRecordNotes: '',
        ApproverID: '',
        ApproverTime: '',
        Isshow: false,
      },
    };
  },
  created() {
    this.GetData();
  },
  methods: {
    GetData() {
      this.IsDataLoad = true;
      let _this = this;
      this.$Http_Post('ConsultSubscribe/ExamineConsultant', {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          _this.UndoTableData = res.Data.UndoTableData;
          _this.DoTableData = res.Data.DoTableData;
          _this.UndoCount = res.Data.UndoCount;
          _this.DoCount = res.Data.DoCount;
          _this.IsDataLoad = false;
          // _this.$parent.RefreshBanCount(_this.UndoCount);
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetData();
    },
    handleCheck(obj) {
      let _this = this;
      _this.dialogTableVisible = true;
      _this.Information.RelieveRecordID = obj.RelieveRecordID;
      _this.Information.VisitorID = obj.VisitorID;
      _this.Information.RelieveRecordNum = obj.RelieveRecordNum;
      _this.Information.Used = obj.Used;
      _this.Information.RelieveRecordCause = obj.RelieveRecordCause;
      _this.Information.CreatorTime = obj.CreatorTime;
      _this.Information.UserName = obj.UserName;
      _this.Information.RelieveRecordState = obj.RelieveRecordState;
      _this.Information.Assessment = obj.Assessment;
      _this.Information.CounselorID = obj.CounselorID;
      _this.Information.RelieveRecordNotes = obj.RelieveRecordNotes;
      _this.Information.ApproverID = obj.ApproverID;
      _this.Information.ApproverTime = obj.ApproverTime;
    },

    selectappointment(starTime, endTime, UserAccount) {
      this.$Http_Post('ConsultSubscribe/GetLeaveAppointment', {
        starTime: starTime,
        endTime: endTime,
        UserID: UserAccount,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.appointmentList = res.Data;
        } else {
          this.$notify.closeAll();
          this.$notify.error({
            title: this.$t('original.languages168'),
            message: res.data.Message,
          });
        }
      });
    },

    UpdateRelieveRecordState(RelieveRecordState, RelieveRecordID) {
      let RelieveRecordNotes = '';
      if (RelieveRecordState == 3) {
        RelieveRecordNotes = this.Information.RelieveRecordNotes;
      }
      this.$Http_Post('ConsultSubscribe/UpdateApplyRelieve', {
        RelieveRecordID: RelieveRecordID,
        RelieveRecordNotes: RelieveRecordNotes,
        RelieveRecordState: RelieveRecordState,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          if (RelieveRecordState == 3) {
            this.$message({
              message: this.$t('original.languages204'),
              type: 'success',
            });
          } else {
            this.$message({
              message: this.$t('original.languages203'),
              type: 'success',
            });
          }
          this.GetData();
          this.dialogTableVisible = false;
          // this.$parent.RefreshBanCount(-1);
        } else {
          this.$message.error(this.$t('original.languages206'));
        }
      });
    },
  },
};
</script>
<style>
.el-tabs {
  height: 100%;
}
.list-cnt {
  height: 100%;
}
</style>
